import { render, staticRenderFns } from "./ProjectReportsTab.vue?vue&type=template&id=6fe5df5e"
import script from "./ProjectReportsTab.vue?vue&type=script&lang=ts"
export * from "./ProjectReportsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports